import {createStore, applyMiddleware, compose} from 'redux';
import thunk from 'redux-thunk';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import rootReducer from './reducers';
import core from './middleware/core';
import app from './middleware/app';

export default function configureStore(initialState) {
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // add support for REACT dev tools
    return createStore(
        rootReducer,
        initialState,
        composeEnhancers(applyMiddleware(thunk, ...core, ...app, reduxImmutableStateInvariant()))
    );
}
